import { AddressParseErrorPayload } from "types/api/addressParseJobs";
import { DestinationAddressResponseDto } from "types/api/destination_addresses";
import {
  AgentEvent,
  AgentFailure,
  AgentPhase,
  describeAgentFailure,
  initialAgentPhase,
  reduceAgentPhase,
} from "utils/agentJobPhase";

export type Failure = AgentFailure;

// The panel runs on the shared agent-job phase machine; the reviewed address
// is the phase result. Input (text + photo) lives outside the phase so it
// survives Try again / Discard.
export type Phase = AgentPhase<DestinationAddressResponseDto>;
export type Event = AgentEvent<DestinationAddressResponseDto>;

export const initialPhase: Phase = initialAgentPhase;

export const reduce = (phase: Phase, event: Event): Phase =>
  reduceAgentPhase(phase, event);

export const canSubmit = (rawInput: string, photo: File | null): boolean =>
  rawInput.trim() !== "" || photo !== null;

// Backend error_payload → what the panel shows; shared with the other agent panels.
export const describeFailure = (
  payload: AddressParseErrorPayload | null,
): Failure => describeAgentFailure(payload);

const FIELD_LABEL_KEYS: Record<string, string> = {
  first_name: "auth.firstName",
  last_name: "auth.lastName",
  phone: "auth.phone",
  email: "auth.email",
  country: "auth.country",
  city: "auth.city",
  zip_code: "auth.postalCode",
  address_1: "auth.address1",
  address_2: "auth.address2",
  street: "auth.street",
  house: "auth.house",
  hull: "auth.hull",
  flat: "auth.flat",
  tax_id: "auth.taxId",
};

// Translation key for a backend field name; unknown fields fall back to the
// raw name (i18next echoes a missing key).
export const fieldLabelKey = (
  field: string,
  country?: string | null,
): string => {
  if (field === "state") {
    return country === "US"
      ? "auth.stateOrRegion.US"
      : "auth.stateOrRegion.other";
  }
  return FIELD_LABEL_KEYS[field] ?? field;
};
